import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import ImageOrVideo from "../Widgets/ImageOrVideo"
import RichTextContainer from "../Widgets/RichTextContainer"
import CentredContentContainer from "../Widgets/CentredContentContainer"
import Carousel from './Carousel'
import Heading from "../Widgets/Heading"

const MAX_IMAGE_WIDTH = 860;
const MARGIN_RIGHT = 20;
const DEFAULT_TITLE_TAG = 'h3';

class ImageGallery extends PureComponent {

    render() {
        const {classes, item} = this.props;
        const {title, title_tag, text, images} = item;

        return (
            <CentredContentContainer>
                {title && (<Heading tag={title_tag || DEFAULT_TITLE_TAG} className={classes.title}>{title}</Heading>)}
                {text && (<RichTextContainer key="content" content={text} />)}
                <div className={classes.imageContainer}>
                    {images && images.length > 0 && (
                        <div className={classes.image}>
                            <Carousel 
                                prevNextContainer={props => <div className={classes.carouselPrevNextContainer}>{props.children}</div>}
                                prevNextAbove={false}
                                items={images.map((i, index) => (
                                    <div key={index} className={classes.flikityCell}>
                                        <ImageOrVideo images={i} sizes={`min-width: ${MAX_IMAGE_WIDTH}px ${MAX_IMAGE_WIDTH}px, 100vw`} />
                                    </div>
                                )
                            )}/>
                        </div>
                    )}
                </div>
            </CentredContentContainer>
        )
    }
}

export default injectSheet((theme) => (
    {
        title: {
            textTransform: 'initial',
            fontStyle: 'normal'
        },
        imageContainer: {
            width: '100%'
        },
        image: {
            display: "flex",
            flexDirection: "column-reverse",
            [theme.breakpoint("tablet")]: {
                flexDirection: "column",
            },
        },
        flikityCell: {
            marginRight: MARGIN_RIGHT,
            width: ({item: {columns}}) => `calc((100% - ${MARGIN_RIGHT * (columns - 1)}px)/${columns})`
        }
    }
))(ImageGallery)



// WEBPACK FOOTER //
// ./src/components/Article/ImageGallery.js